const genericUrl = process.env.REACT_APP_API_URL;

export async function PostBuyShopItem(idUser: string, idItem: string, idAula: string) {
    try {
        const response = await fetch(`${genericUrl}:8061/jutge/shop/buy/${idUser}/${idItem}/${idAula}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.ok) return { ok: true };
        else {
            const msg = await response.text();
            return { ok: false, msg };
        }
    } catch (e) {
        console.error(e);
        return { ok: false, msg: "Error de conexión" };
    }
}
